import { dialogPortal } from '@/modules/common/helpers/portal';
import InstrumentRiskModal from './InstrumentRiskModal.vue';
import { RiskTermsModalProps } from './types';

export const openRiskTermsModal = async (props: RiskTermsModalProps) =>
  dialogPortal(InstrumentRiskModal, props);
